import { render } from "./DefSlide.vue?vue&type=template&id=c09eada2&scoped=true"
import script from "./DefSlide.vue?vue&type=script&lang=js"
export * from "./DefSlide.vue?vue&type=script&lang=js"

import "./DefSlide.vue?vue&type=style&index=0&id=c09eada2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09eada2"]])

export default __exports__